import { render, staticRenderFns } from "./VaimoLogo.vue?vue&type=template&id=5924971c&"
import script from "./VaimoLogo.vue?vue&type=script&lang=ts&"
export * from "./VaimoLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports